
import * as React from 'react';

import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { type Row } from '@process-advisor/process-miner/api/methods/slicers/setVariantSlicerSelectedGridData';
import { DataGrid } from '@process-advisor/process-miner/filters/variants/dataGrid';
import { variantGridColumnsVisualizer } from '@process-advisor/process-miner/filters/variants/variantGridColumnsVisualizer';

import { Event } from '@process-advisor/process-miner/api/events';

type Props = {
    setApplyEnabled: (value: boolean) => void;
    selectionMode: string;
    mode: string;
};


export const VariantsGrid: React.FC<Props> = ({ setApplyEnabled, selectionMode, mode }) => {
    const [data, setData] = React.useState<Row[]>([]);
    const [rows, setRows] = React.useState();
    const [columns, setColumns] = React.useState<any>();
    const [height, setHeight] = React.useState<any>();

    React.useEffect(() => {
        setData(apiProvider.variantsTable({}));
  
        setColumns(variantGridColumnsVisualizer)
        setHeight('320px')
        setData(apiProvider.variantsTable({}));
    }, [mode]);

    React.useEffect(() => {

        const listener = () => { 
            setData(apiProvider.variantsTable({}));
        };       
        apiProvider.on(Event.updateDurationColumns, listener);
        apiProvider.on(Event.resetTimeFilter, listener);
        apiProvider.on(Event.processDiscoveryRule, listener);
        return () => {
            apiProvider.off(Event.updateDurationColumns, listener);
            apiProvider.off(Event.resetTimeFilter, listener);
            apiProvider.off(Event.processDiscoveryRule, listener);
        };
    }, []);

    React.useEffect(() => {
        setRows(data.map((row, id) => ({ id, ...row })))
    }, [data]);

    return (
        <DataGrid
            rows={rows}
            columns={columns}
            height={height}
            mode={mode}
            setApplyEnabled={setApplyEnabled} />
    );
};
